import React from "react";
import Section from "./Section";
import { experience } from "../data/ExperienceDetails";

const Experience = () => (
  <Section
    id="experience"
    title="Experience"
    subtitle="Where I've worked, and what I built while I was there."
  >
    <ol className="space-y-4">
      {experience.map((job) => (
        <li
          key={`${job.company}-${job.period}`}
          className="grid gap-1 rounded-2xl border border-line bg-surface p-5 sm:grid-cols-[10rem_1fr] sm:gap-6 sm:p-6"
        >
          <p className="font-mono text-xs text-faint sm:pt-1">{job.period}</p>
          <div>
            <h3 className="text-lg font-semibold">{job.role}</h3>
            <p className="mt-1 flex flex-wrap items-center gap-2">
              <span className="rounded-full border border-line px-2.5 py-0.5 text-xs font-medium text-fg">
                {job.company}
              </span>
              <span className="text-xs text-faint">{job.location}</span>
            </p>
            <ul className="mt-3 space-y-1.5">
              {job.highlights.map((point) => (
                <li
                  key={point}
                  className="flex gap-2 text-sm text-muted"
                >
                  <span className="mt-2 h-1 w-1 shrink-0 rounded-full bg-faint" aria-hidden="true" />
                  {point}
                </li>
              ))}
            </ul>
          </div>
        </li>
      ))}
    </ol>
  </Section>
);

export default Experience;
